let currentObserver: IntersectionObserver | null = null

function observeParallaxAdContainers() {
    currentObserver?.disconnect()

    const containers = document.querySelectorAll<HTMLElement>(".parallax-ad-container")

    if (containers.length === 0) {
        return
    }

    currentObserver = new IntersectionObserver(
        (entries) => {
            for (const entry of entries) {
                const container = entry.target.closest<HTMLElement>(".parallax-ad-container")
                if (!container) {
                    continue
                }

                if (entry.isIntersecting) {
                    container.classList.add("in-view")
                } else {
                    container.classList.remove("in-view")
                }
            }
        },
        {
            threshold: 0.9,
            rootMargin: "0px 0px -80px 0px",
        },
    )

    for (const container of containers) {
        const target = container.querySelector<HTMLElement>(".parallax-ad-content") ?? container
        currentObserver.observe(target)
    }
}

window.addEventListener("parallax-ad.inserted", () => {
    observeParallaxAdContainers()
})
